// Anima l'ingresso delle card aggiunte da "Carica altre…"/ricerca e l'uscita
// di quelle rimosse da "Mostra meno…", condiviso da archivio-servizi.js,
// archivio-collaborazioni.js e archivio-rassegna-stampa.js (stessa struttura
// di griglia/card in tutti e tre, vedi @include card-load-animation in
// _mixins.scss). Con prefers-reduced-motion le card compaiono/scompaiono di
// scatto, come prima di questo modulo.
const STAGGER_STEP_MS = 40;
const MAX_STAGGERED_CARDS = 8;
const LEAVE_TIMEOUT_MS = 350;
// Margine oltre la durata dell'animazione CSS (@include card-load-animation
// in _mixins.scss) per il fallback sotto: deve coprire il caso peggiore,
// scaglionamento massimo incluso.
const ENTER_FALLBACK_MARGIN_MS = 600;

function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// `cards` nell'ordine in cui sono apparse nella griglia (le prime della
// battuta entrano leggermente prima delle ultime); lo scaglionamento resta
// piatto dopo le prime MAX_STAGGERED_CARDS per non allungare troppo
// l'animazione quando arriva una pagina intera di card.
export function animateCardsIn(cards) {
    if (prefersReducedMotion()) {
        return;
    }

    cards.forEach((card, index) => {
        const delay = Math.min(index, MAX_STAGGERED_CARDS) * STAGGER_STEP_MS;

        let settled = false;

        const finish = () => {
            if (settled) {
                return;
            }
            settled = true;
            card.classList.remove("is-entering");
            card.style.removeProperty("--card-in-delay");
        };

        card.style.setProperty("--card-in-delay", `${delay}ms`);
        card.classList.add("is-entering");
        card.addEventListener("animationend", finish, { once: true });

        // Fallback: se animationend non parte mai (es. la card viene
        // spostata/rimossa da un'altra interazione prima che l'animazione
        // finisca), non lasciare "is-entering"/--card-in-delay appesi per
        // sempre — stesso principio del fallback in animateCardsOut().
        setTimeout(finish, delay + ENTER_FALLBACK_MARGIN_MS);
    });
}

// Rimuove `cards` dal DOM dopo la transizione di uscita, poi chiama `onDone`
// una sola volta. Con reduced motion, o se le card sono già zero, rimuove
// subito e chiama `onDone` in modo sincrono.
export function animateCardsOut(cards, onDone) {
    if (!cards.length) {
        onDone();
        return;
    }

    if (prefersReducedMotion()) {
        cards.forEach((card) => card.remove());
        onDone();
        return;
    }

    let settled = false;
    let remaining = cards.length;

    const finish = () => {
        if (settled) {
            return;
        }
        settled = true;
        onDone();
    };

    cards.forEach((card) => {
        card.classList.add("is-leaving");
        card.addEventListener(
            "transitionend",
            () => {
                card.remove();
                remaining -= 1;
                if (remaining <= 0) {
                    finish();
                }
            },
            { once: true }
        );
    });

    // Fallback: se transitionend non parte (es. la card è già stata rimossa
    // da un'altra interazione nel frattempo), rimuove comunque tutto e
    // sblocca l'aggiornamento della UI invece di restare in attesa per sempre.
    setTimeout(() => {
        cards.forEach((card) => card.isConnected && card.remove());
        finish();
    }, LEAVE_TIMEOUT_MS);
}
